import { Alert, Card, Spinner } from '@1k5-tech-es/grado-react';
import type { ReactNode } from 'react';

import type { Status } from '../api/types';

/** Traffic-light fills, identical to the PDF reports. */
export const STATUS_CLASSES: Record<Status, string> = {
  green: 'bg-status-green text-status-green-text',
  yellow: 'bg-status-yellow text-status-yellow-text',
  red: 'bg-status-red text-status-red-text',
};

export function StatusPill({ status, children }: { status: Status | null; children: ReactNode }) {
  return (
    <span
      className={`inline-flex min-w-16 justify-center rounded-full px-2.5 py-0.5 text-xs font-semibold tabular-nums ${
        status ? STATUS_CLASSES[status] : 'text-muted-foreground'
      }`}
    >
      {children}
    </span>
  );
}

export function LoadingBlock() {
  return (
    <Card className="flex items-center justify-center gap-3 p-12 text-sm text-muted-foreground">
      <Spinner decorative /> Cargando…
    </Card>
  );
}

export function ErrorBlock({ error }: { error: unknown }) {
  return (
    <Alert tone="danger" title="Se ha producido un error">
      {error instanceof Error ? error.message : 'Se ha producido un error inesperado.'}
    </Alert>
  );
}
